import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = () => {
  ReactGA.initialize('G-VHWP5TBG0V', {
    gaOptions: {
      siteSpeedSampleRate: 100,
    },
    gtagOptions: {
      send_page_view: false // We'll send page views manually
    }
  });
  
  console.log('Google Analytics initialized with ID: G-VHWP5TBG0V');
};

// Track page views
export const logPageView = (path, title) => {
  ReactGA.send({ 
    hitType: 'pageview', 
    page: path,
    title: title || document.title
  });
  
  console.log(`GA Page View: ${path} - ${title || document.title}`);
};

// Track custom events
export const logEvent = (category, action, label = '', value = 0) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: value
  });
  
  console.log(`GA Event: ${category} - ${action} - ${label}`);
};

// Specific event tracking functions
export const trackContactFormSubmit = (formType = 'contact_page') => {
  logEvent('Contact', 'Form Submit', formType, 1);
};

export const trackPhoneClick = (location = 'unknown') => {
  logEvent('Contact', 'Phone Click', location, 1);
};

export const trackWhatsAppClick = (location = 'unknown') => {
  logEvent('Contact', 'WhatsApp Click', location, 1);
};

export const trackServiceView = (serviceName) => {
  logEvent('Services', 'Service Page View', serviceName, 1);
};

export const trackProjectView = (projectName) => {
  logEvent('Projects', 'Project Detail View', projectName, 1);
};

export const trackBlogView = (blogTitle) => {
  logEvent('Blog', 'Blog Post View', blogTitle, 1);
};

export const trackCTAClick = (ctaName, location) => {
  logEvent('CTA', 'Click', `${ctaName} - ${location}`, 1);
};

export const trackScrollDepth = (depth) => {
  logEvent('Engagement', 'Scroll Depth', `${depth}%`, depth);
};

export const trackSearch = (searchTerm) => {
  logEvent('Search', 'Site Search', searchTerm, 1);
};

export const trackDownload = (fileName) => {
  logEvent('Downloads', 'File Download', fileName, 1);
};

export const trackVideoPlay = (videoName) => {
  logEvent('Video', 'Play', videoName, 1);
};

export const trackSocialShare = (platform, page) => {
  logEvent('Social', 'Share', `${platform} - ${page}`, 1);
};

// Track user timing (performance)
export const trackTiming = (category, variable, value, label) => {
  ReactGA.gtag('event', 'timing_complete', {
    name: variable,
    value: value,
    event_category: category,
    event_label: label
  });
};

// Set user properties
export const setUserProperty = (property, value) => {
  ReactGA.gtag('set', 'user_properties', {
    [property]: value
  });
};

// Track exceptions
export const trackException = (description, fatal = false) => {
  ReactGA.gtag('event', 'exception', {
    description: description,
    fatal: fatal
  });
};

export default {
  initGA,
  logPageView,
  logEvent,
  trackContactFormSubmit,
  trackPhoneClick,
  trackWhatsAppClick,
  trackServiceView,
  trackProjectView,
  trackBlogView,
  trackCTAClick,
  trackScrollDepth,
  trackSearch,
  trackDownload,
  trackVideoPlay,
  trackSocialShare,
  trackTiming,
  setUserProperty,
  trackException
};
